// eslint-disable-next-line no-unused-vars
import React from 'react';
var behance = function behance(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48.383c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z",
    className: "background"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.667 18.55H27.5v-2.334h8.167v2.334zm2.013 11.666c-.515 1.514-2.367 3.5-5.95 3.5-3.587 0-6.492-2.017-6.492-6.62 0-4.562 2.712-6.907 6.377-6.907 3.596 0 5.791 2.079 6.27 5.163.092.59.128 1.386.111 2.497h-9.364c.151 3.746 4.063 3.864 5.352 2.367h3.696zm-8.967-4.666h5.793c-.123-1.805-1.325-2.59-2.89-2.59-1.71 0-2.657.897-2.903 2.59zm-11.17 8.152H10V16.241h8.112c6.389.094 6.51 6.351 3.173 8.057 4.038 1.47 4.173 9.404-3.741 9.404zM13.5 23.216h4.181c2.926 0 3.39-3.5-.364-3.5H13.5v3.5zm3.956 3.5H13.5v3.519h3.898c3.564 0 3.346-3.519.058-3.519z",
    className: "logo"
  }));
};
behance.defaultProps = {
  width: "49",
  height: "49",
  viewBox: "0 0 48 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var dribbble = function dribbble(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48.383c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z",
    className: "background"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 8.383c-8.833 0-16 7.167-16 16s7.167 16 16 16c8.816 0 16-7.167 16-16s-7.184-16-16-16zm10.568 7.375a13.604 13.604 0 0 1 3.09 8.504c-.452-.087-4.964-1.007-9.51-.434-.105-.226-.191-.469-.296-.712-.277-.66-.59-1.336-.902-1.978 5.033-2.048 7.323-4.998 7.618-5.38zM24 10.743c3.47 0 6.646 1.302 9.059 3.436-.243.347-2.308 3.106-7.167 4.929-2.24-4.113-4.72-7.48-5.102-8 1.023-.243 2.1-.365 3.21-.365zm-5.813 1.284c.364.486 2.793 3.87 5.067 7.896-6.386 1.7-12.026 1.666-12.634 1.666.885-4.234 3.749-7.757 7.567-9.562zM10.325 24.4v-.416c.59.017 7.22.104 14.04-1.944.399.764.763 1.545 1.11 2.326-.174.052-.364.104-.538.156-7.045 2.273-10.794 8.486-11.106 9.006a13.635 13.635 0 0 1-3.506-9.128zM24 38.058a13.571 13.571 0 0 1-8.382-2.881c.243-.503 3.02-5.848 10.725-8.538.034-.017.052-.017.087-.035 1.926 4.98 2.707 9.163 2.915 10.36A13.44 13.44 0 0 1 24 38.058zm7.618-2.343c-.139-.833-.867-4.824-2.655-9.735 4.286-.677 8.035.433 8.503.59-.59 3.8-2.776 7.08-5.848 9.145z",
    className: "logo"
  }));
};
dribbble.defaultProps = {
  width: "50",
  height: "49",
  viewBox: "0 0 49 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var facebook = function facebook(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48.383c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z",
    className: "background"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.648 39.287V27.64h3.971l.595-4.54h-4.566v-2.898c0-1.314.371-2.21 2.285-2.21h2.441v-4.06c-.422-.056-1.87-.18-3.557-.18-3.52 0-5.93 2.116-5.93 6.001v3.348h-3.98v4.539h3.98v11.647h4.761z",
    className: "logo"
  }));
};
facebook.defaultProps = {
  width: "49",
  height: "49",
  viewBox: "0 0 48 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var instagram = function instagram(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48.383c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z",
    className: "background"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.994 13.023c3.74 0 4.178.016 5.656.083 1.367.061 2.106.289 2.6.483a4.343 4.343 0 0 1 1.611 1.045c.489.49.795.956 1.045 1.612.188.494.422 1.233.483 2.6.067 1.478.083 1.917.083 5.657s-.016 4.178-.083 5.657c-.061 1.366-.289 2.105-.483 2.6a4.345 4.345 0 0 1-1.045 1.611 4.276 4.276 0 0 1-1.611 1.045c-.494.189-1.233.422-2.6.484-1.478.066-1.917.083-5.656.083-3.738 0-4.177-.017-5.655-.083-1.367-.062-2.106-.29-2.6-.484a4.344 4.344 0 0 1-1.611-1.045 4.277 4.277 0 0 1-1.045-1.611c-.189-.495-.422-1.234-.483-2.6-.067-1.479-.083-1.918-.083-5.657 0-3.74.016-4.179.083-5.657.061-1.367.289-2.106.483-2.6a4.344 4.344 0 0 1 1.045-1.612 4.276 4.276 0 0 1 1.61-1.045c.495-.188 1.234-.422 2.6-.483 1.479-.072 1.923-.083 5.656-.083zm0-2.523c-3.8 0-4.277.017-5.772.083-1.489.067-2.505.306-3.394.65a6.82 6.82 0 0 0-2.478 1.617 6.943 6.943 0 0 0-1.617 2.479c-.344.889-.583 1.906-.65 3.4-.066 1.49-.083 1.968-.083 5.768 0 3.801.017 4.279.083 5.774.067 1.489.306 2.506.65 3.4.356.923.84 1.7 1.617 2.479a6.941 6.941 0 0 0 2.478 1.617c.889.344 1.905.583 3.4.65 1.494.066 1.966.083 5.772.083s4.278-.017 5.772-.083c1.49-.067 2.506-.306 3.4-.65a6.82 6.82 0 0 0 2.478-1.617 6.943 6.943 0 0 0 1.617-2.479c.344-.889.583-1.906.65-3.4.066-1.495.083-1.968.083-5.774s-.017-4.278-.083-5.773c-.067-1.49-.306-2.506-.65-3.4a6.823 6.823 0 0 0-1.617-2.48 6.942 6.942 0 0 0-2.478-1.616c-.889-.345-1.905-.583-3.4-.65-1.5-.061-1.978-.078-5.778-.078z",
    className: "logo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.994 17.312a7.19 7.19 0 0 0 0 14.381 7.187 7.187 0 0 0 7.19-7.19 7.187 7.187 0 0 0-7.19-7.19zm0 11.853a4.667 4.667 0 0 1-4.666-4.668 4.667 4.667 0 1 1 9.333 0 4.667 4.667 0 0 1-4.667 4.668zM31.466 18.7a1.678 1.678 0 1 0 0-3.355 1.678 1.678 0 0 0 0 3.355z",
    className: "logo"
  }));
};
instagram.defaultProps = {
  width: "49",
  height: "49",
  viewBox: "0 0 48 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var github = function github(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 24.383c0 12.703-10.297 23-23 23s-23-10.297-23-23c0-12.702 10.297-23 23-23s23 10.297 23 23z",
    className: "background"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.758 40.251c0 .534-.367 1.16-1.366.972 1.289.32 4.358.959 6.323.959 1.964 0 5.041-.64 6.334-.961-1.014.198-1.374-.432-1.374-.97 0-.665.023-2.84.023-5.544 0-1.885-.64-3.114-1.357-3.741 4.454-.5 9.133-2.209 9.133-9.969 0-2.205-.776-4.007-2.058-5.422.208-.51.892-2.564-.197-5.347 0 0-1.677-.542-5.494 2.072a19.053 19.053 0 0 0-5.01-.68c-1.7.007-3.41.232-5.006.68-3.822-2.614-5.501-2.072-5.501-2.072-1.087 2.783-.402 4.838-.194 5.347-1.28 1.415-2.061 3.217-2.061 5.422 0 7.742 4.67 9.474 9.112 9.985-.572.504-1.09 1.396-1.27 2.701-1.141.517-4.036 1.41-5.82-1.679 0 0-1.057-1.94-3.066-2.082 0 0-1.951-.026-.136 1.228 0 0 1.31.622 2.22 2.956 0 0 1.174 3.606 6.738 2.384.009 1.688.027 3.28.027 3.761z",
    className: "logo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.381 30.81c-.043.1-.196.13-.335.061-.142-.066-.222-.203-.176-.304.042-.103.195-.131.337-.063.142.066.223.204.174.305zM13.174 31.722c-.094.09-.276.048-.4-.093-.128-.141-.152-.33-.057-.42.096-.09.273-.048.4.093.13.143.154.33.057.42zM13.945 32.885c-.12.087-.316.006-.437-.173-.12-.18-.12-.396.003-.482.12-.087.314-.009.437.17.12.182.12.397-.003.485zM15.002 34.01c-.107.122-.336.089-.503-.078-.171-.163-.219-.394-.111-.516s.338-.088.507.077c.17.163.221.396.107.517zM16.46 34.662c-.048.159-.268.23-.49.163-.22-.07-.365-.254-.32-.414.045-.16.266-.234.49-.162.22.069.366.252.32.413zM18.061 34.783c.006.167-.182.305-.415.308-.234.005-.423-.13-.426-.293 0-.169.184-.305.418-.31.232-.004.423.13.423.295zM19.551 34.522c.028.162-.134.329-.365.373-.227.043-.437-.057-.466-.218-.028-.167.136-.334.363-.377.232-.041.439.056.468.222z",
    className: "background"
  }));
};
github.defaultProps = {
  width: "49",
  height: "49",
  viewBox: "0 0 48 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var linkedin = function linkedin(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48.383c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z",
    className: "background"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.578 12.896a2.655 2.655 0 0 1 2.654 2.652 2.654 2.654 0 1 1-2.654-2.652zm-2.292 22.048h4.582V20.218h-4.582v14.726zM20.74 20.217h4.386v2.011h.063c.61-1.157 2.104-2.378 4.33-2.378 4.631 0 5.486 3.05 5.486 7.017v8.076h-4.572v-7.16c0-1.71-.032-3.906-2.377-3.906-2.381 0-2.745 1.86-2.745 3.78v7.286H20.74V20.217z",
    className: "logo"
  }));
};
linkedin.defaultProps = {
  width: "49",
  height: "49",
  viewBox: "0 0 48 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var mail = function mail(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48.383c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z",
    className: "background"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6 15.383H11.4c-.77 0-1.4.633-1.4 1.407v13.888c0 .774.63 1.407 1.4 1.407h25.2c.77 0 1.4-.633 1.4-1.407V16.79c0-.773-.63-1.406-1.4-1.406zm0 .88c.285 0 .525.24.525.526v13.89c0 .285-.24.527-.525.527H11.4a.533.533 0 0 1-.525-.528V16.79c0-.285.24-.527.525-.527h25.2z",
    className: "logo"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 16.79c0-.911.74-1.657 1.65-1.657h25.2c.91 0 1.65.746 1.65 1.657v13.888c0 .91-.74 1.657-1.65 1.657H11.4c-.91 0-1.65-.746-1.65-1.657V16.79zm1.65-1.157c-.63 0-1.15.52-1.15 1.157v13.888c0 .637.52 1.157 1.15 1.157h25.2c.63 0 1.15-.52 1.15-1.157V16.79c0-.636-.52-1.156-1.15-1.156H11.4zm0 .88a.283.283 0 0 0-.275.276v13.89c0 .148.13.277.275.277h25.2a.284.284 0 0 0 .275-.278V16.79a.283.283 0 0 0-.275-.277H11.4zm-.775.276c0-.422.351-.777.775-.777h25.2c.424 0 .775.355.775.777v13.89a.783.783 0 0 1-.775.777H11.4a.783.783 0 0 1-.775-.778V16.79z",
    className: "logo"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.754 25.699l-13.263-9.083.482-.742 12.781 8.753 12.782-8.753.481.742L23.755 25.7z",
    className: "logo"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.903 15.523l12.851 8.801 12.852-8.8.754 1.16-13.606 9.318-13.605-9.317.754-1.162zm.14.702l-.21.323 12.921 8.848 12.921-8.848-.21-.323-12.71 8.705-12.712-8.705z",
    className: "logo"
  }));
};
mail.defaultProps = {
  width: "49",
  height: "49",
  viewBox: "0 0 48 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var twitter = function twitter(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48.383c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z",
    className: "background"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.626 35.865c10.351 0 16.011-8.648 16.011-16.148 0-.246-.005-.49-.016-.734a11.504 11.504 0 0 0 2.808-2.938 11.164 11.164 0 0 1-3.232.893 5.687 5.687 0 0 0 2.474-3.14 11.217 11.217 0 0 1-3.573 1.378 5.6 5.6 0 0 0-4.107-1.793c-3.108 0-5.629 2.542-5.629 5.675 0 .446.05.879.146 1.294-4.676-.237-8.824-2.495-11.599-5.93a5.694 5.694 0 0 0-.762 2.853c0 1.97.993 3.708 2.504 4.725a5.55 5.55 0 0 1-2.549-.71v.072c0 2.749 1.94 5.044 4.514 5.564a5.597 5.597 0 0 1-2.541.097c.716 2.255 2.793 3.896 5.257 3.942a11.231 11.231 0 0 1-6.99 2.43c-.454 0-.902-.026-1.342-.079a15.833 15.833 0 0 0 8.626 2.55z",
    className: "logo"
  }));
};
twitter.defaultProps = {
  width: "49",
  height: "49",
  viewBox: "0 0 48 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var website = function website(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48.383c13.255 0 24-10.745 24-24s-10.745-24-24-24-24 10.745-24 24 10.745 24 24 24z",
    className: "background"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.161 13.383H11.839a1.5 1.5 0 0 0-1.5 1.5v18a1.5 1.5 0 0 0 1.5 1.5h24.322a1.5 1.5 0 0 0 1.5-1.5v-18a1.5 1.5 0 0 0-1.5-1.5zm-24.322-1.5a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h24.322a3 3 0 0 0 3-3v-18a3 3 0 0 0-3-3H11.839z",
    className: "logo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.894 13.127H37.97v3.94H9.894v-3.94zM34.867 29.965l-2.456 1.544-4.818-7.663 2.455-1.544 4.819 7.663z",
    className: "logo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.127 26.742l-4.625 2.908-.002-10.267 2.638 4.195 1.989 3.164z",
    className: "logo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.781 23.847l-4.64 2.918-3.02-4.804-1.621-2.578 9.281 4.464z",
    className: "logo"
  }));
};
website.defaultProps = {
  width: "49",
  height: "49",
  viewBox: "0 0 48 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export const SocialMediaIcons = {
  behance,
  dribbble,
  facebook,
  instagram,
  github,
  linkedin,
  mail,
  twitter,
  website
};
export const SocialMediaIconsMetadata = {
  behance: {
    name: 'behance'
  },
  dribbble: {
    name: 'dribbble'
  },
  facebook: {
    name: 'facebook'
  },
  instagram: {
    name: 'instagram'
  },
  github: {
    name: 'github'
  },
  linkedin: {
    name: 'linkedin'
  },
  mail: {
    name: 'mail'
  },
  twitter: {
    name: 'twitter'
  },
  website: {
    name: 'website'
  }
};